import { render } from "./ProfileSettingsEmail.vue?vue&type=template&id=7dcc09f1&scoped=true"
import script from "./ProfileSettingsEmail.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsEmail.vue?vue&type=script&lang=js"

import "@/css/components/profile-settings-email.css?vue&type=style&index=0&id=7dcc09f1&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcc09f1"]])

export default __exports__